<template>
  <el-dialog
    :visible="value"
    title="添加类目"
    @close="$emit('change', false)"
  >
    <el-form label-position="top">
      <el-form-item label="类目">
        <el-cascader :options="cascaderOptions" :value="[form.first, form.second]" @change="handleSelect" />
        <div v-if="category">{{ category.scope }}</div>
      </el-form-item>
      <template v-if="innerListGroup.length">
        <el-form-item label="选择资质方案" v-if="innerListGroup.length > 1">
          <el-select v-model="certicatesIndex">
            <el-option v-for="(item, index) in innerListGroup" :key="index" :value="index" :label="`方案${index + 1}`"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传资质资料">
          <div v-for="item in innerListGroup[certicatesIndex]" :key="item.name">
            <div style="line-height: 1.3;margin-bottom: 10px;"><component :is="item.url ? 'a' : 'span'" v-bind="{ href: item.url, target: '_blank' }">{{ item.name }}</component></div>
            <div><bean-upload-form v-model="form[item.name]" accept="*" /></div>
          </div>
        </el-form-item>
      </template>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('change', false)">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
  import { Vue, Component, Prop, Model } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class WechatCategoryDialog extends Vue {
    @Model('change', { type: Boolean }) value;
    @Prop({ type: Array, default: () => [] }) categories; // 已选择的类目
    @Prop({ type: Array, default: () => [] }) options;

    form = {};
    certicatesIndex = 0; // 选择资质方案

    get cascaderOptions() {
      const mapChildren = (children) => {
        return children
          .filter(childId => this.options.find(categoryItem => categoryItem.id === childId))
          .map(childId => {
            const item = this.options.find(categoryItem => categoryItem.id === childId);
            const children = mapChildren(item.children);
            return {
              ...item,
              label: item.name,
              value: item.id,
              children: children.length ? children : undefined
            }
          });
      }

      return this.options
        .filter(item => item.level === 1)
        .map(item => ({
          ...item,
          label: item.name,
          value: item.id,
          children: mapChildren(item.children)
        }));
    }

    get category() {
      if (!this.form.second) {
        return null;
      }
      return this.options.find(item => item.id === this.form.second);
    }

    get innerListGroup() {
      return _.get(this.category, 'qualify.exter_list', [])
        .map(item => item.inner_list);
    }

    handleSelect([first, second]) {
      if (this.categories.find(item => item.first === first && item.second === second)) {
        this.$message.error('不能添加相同服务类目');
        this.form = {};
        return;
      }
      this.form = {
        ...this.form,
        first,
        second
      }
    }

    handleConfirm() {
      const { first, second } = this.form;
      if (!second) {
        this.$message.error('请选择类目');
        return;
      }
      const certicates = _.get(this.innerListGroup, this.certicatesIndex, [])
        .map(item => ({ key: item.name, value: this.form[item.name] }));

      if (certicates.filter(item => !item.value).length) {
        this.$message.error('请上传资质');
        return;
      }
      const form = {
        first,
        second,
        certicates
      }
      this.$emit('success', form);
    }
  }

</script>

<style>

</style>
